import React, { useState, useEffect, useRef, useContext } from "react";
import * as braze from "@braze/web-sdk";
import { BreakpointContext } from "components/common";
import { BoostTerm, BoostTier } from "@tomocredit/common-fe/types";
import BoostContainer from "pages/Boost/components/BoostContainer";
import CheckoutForm from "./components/ChargebeeCheckoutForm";

const CheckoutPage = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const emailRaw = queryParameters.get("email");
  const tierRaw = queryParameters.get("tier");
  const termRaw = queryParameters.get("term");
  const referralCode = queryParameters.get("referralCode") || "";

  const emailFromQueryParam = typeof emailRaw === "string" ? emailRaw.trim().toLowerCase() : "";

  const checkoutTier = typeof tierRaw === "string" && Object.values(BoostTier).includes(tierRaw.toUpperCase())
    ? tierRaw.toUpperCase()
    : BoostTier.VIP;

  const checkoutTerm = typeof termRaw === "string" && Object.values(BoostTerm).includes(termRaw.toLowerCase())
    ? termRaw.toLowerCase()
    : BoostTerm.MONTHLY;

  // alternatively can get from url params

  const { isBelow } = useContext(BreakpointContext);
  const belowMd = isBelow("md"); // 768

  const [promotionCredit, setPromotionCredit] = useState(0);
  const [promotionPercentOff, setPromotionPercentOff] = useState(0);

  // checkout form ref
  const checkoutFormRef = useRef(null);
  const checkoutFormContainerRef = useRef(null);
  const errorMessageRef = useRef(null);

  // update tier param on tier selection
  useEffect(() => {
    if (emailFromQueryParam && checkoutTier && checkoutTerm) {
      window?.gtag?.("event", "boost_checkout_product_selected", {
        tier: checkoutTier,
        boostTerm: checkoutTerm,
        email: emailFromQueryParam,
      });
      braze.logCustomEvent("checkout_plan_selected", { term: checkoutTerm, tier: checkoutTier });
    }
  }, []);

  // render payment form
  return (
    <div>
      <BoostContainer relative disablePopup disableFooter background="pricing">
        <div style={{ minWidth: 350 }}>
          <div
            className="flex justify-center items-center min-h-screen w-full"
            ref={checkoutFormContainerRef}
          >
            <CheckoutForm
              email={emailFromQueryParam}
              productTier={checkoutTier}
              productTerm={checkoutTerm}
              innerRef={checkoutFormRef}
              errorMessageRef={errorMessageRef}
              belowMd={belowMd}
              referralCode={referralCode}
              promotionCredit={promotionCredit}
              setPromotionCredit={setPromotionCredit}
              promotionPercentOff={promotionPercentOff}
              setPromotionPercentOff={setPromotionPercentOff}
            />
          </div>
        </div>
      </BoostContainer>
    </div>
  );
};

export default CheckoutPage;
